export const meetingSelector = (state) => state.meetingReducer;
